import { ELocationModalActions } from '../../actions/locationModal';
import { ILocationModalState } from '../../types/locationModal';
import { TReduxActions } from '../../types/redux';

export const defaultState: ILocationModalState = {
  isOpen: false,
};

export function locationModalReducer(
  state: ILocationModalState = defaultState,
  action: TReduxActions,
): ILocationModalState {
  switch (action.type) {
    case ELocationModalActions.Open:
      return {
        ...state,
        isOpen: true,
      };
    case ELocationModalActions.Close:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
